module.exports = __webpack_public_path__ + "img/logo.4445ab93.svg";